// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1rU2T","right":"styles_right__17Rwy"};